export interface PopupProps {
  children: React.ReactElement;
  isOpen: boolean;
  content: React.ReactElement;
  parentElementRef?: HTMLDivElement | null;
  onClickOutside?: () => void;
  containerPosition?: PopupPosition;
  alignContent?: PopupAlign;
  arrowColor?: string;
  containerClassName?: string;
}

export const ARROW_COLOR = {
  LIGHT: 'var(--neutral-100)',
  PURPLE: 'var(--primary-800)',
};

export enum PopupPosition {
  BOTTOM = 'bottom',
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum PopupAlign {
  START = 'start',
  CENTER = 'center',
  END = 'end',
}
